import { FunctionComponent, ReactNode, useCallback, useState } from 'react'
import contextViewport, { ViewportOrientationValues } from '@contexts/viewport'
import { layout } from '@measures/responsive'
import {
  ViewportDimensions,
  ViewportOrientation,
  ViewportTypeValues,
} from '@contexts/viewport'
import useViewportDimensions from '@hooks/useViewportDimensions'

const {
  desktop: { minWidth: minWidthDesktop },
  tablet: { minWidth: minWidthTablet },
} = layout

const {
  ViewportWidthContext,
  ViewportHeightContext,
  ViewportTypeContext,
  ViewportOrientationContext,
} = contextViewport

const ViewportContextProvider: FunctionComponent<{ children?: ReactNode }> = ({
  children,
}) => {
  const [viewportWidth, setViewportWidth] =
    useState<ViewportDimensions['width']>(1280)
  const [viewportHeight, setViewportHeight] =
    useState<ViewportDimensions['height']>(1024)
  const [viewportType, setViewportType] = useState<ViewportTypeValues>(
    ViewportTypeValues.DESKTOP
  )
  const [viewportOrientation, setViewportOrientation] =
    useState<ViewportOrientationValues>(ViewportOrientationValues.LANDSCAPE)

  const onSizeChange = useCallback(({ width, height }: ViewportDimensions) => {
    setViewportWidth(width)
    setViewportHeight(height)
  }, [])

  const onViewportChange = useCallback(({ width }: ViewportDimensions) => {
    const type =
      width < minWidthTablet
        ? ViewportTypeValues.MOBILE
        : width < minWidthDesktop
        ? ViewportTypeValues.TABLET
        : ViewportTypeValues.DESKTOP

    setViewportType(type)
  }, [])

  const onOrientationChange = useCallback(
    ({ orientation }: ViewportOrientation) => {
      setViewportOrientation(orientation)
    },
    []
  )

  useViewportDimensions({ onSizeChange, onViewportChange, onOrientationChange })

  return (
    <ViewportWidthContext.Provider value={viewportWidth}>
      <ViewportHeightContext.Provider value={viewportHeight}>
        <ViewportTypeContext.Provider value={viewportType}>
          <ViewportOrientationContext.Provider value={viewportOrientation}>
            {children}
          </ViewportOrientationContext.Provider>
        </ViewportTypeContext.Provider>
      </ViewportHeightContext.Provider>
    </ViewportWidthContext.Provider>
  )
}

export default ViewportContextProvider
